<template>
	<section class="view-ui-media-map">
		<ChalkyVenueMap
			class="hide-streetview"
			v-bind:centerLatitude="mapLatitude"
			v-bind:centerLongitude="mapLongitude"
			v-bind:centerOffsetY="centerOffsetY"
			v-bind:centerOnMarker="true"
			v-bind:userLatitude="$store.getters['location/latitude']"
			v-bind:userLongitude="$store.getters['location/longitude']"
			v-bind:venueCollection="venueCollection"
			v-bind:zoom="mapZoom"
			v-on:click="$emit('click')"
			v-on:map:drag="$emit('map:drag', $event)"
			v-on:map:zoom="$emit('map:zoom', $event)"
			v-on:marker:click="$emit('marker:click', $event)"
		/>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Media
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiMediaMap extends ViewBase {
		/**
		 * @type number
		 */
		@Prop({ default: -100 })
		public centerOffsetY!: number;

		/**
		 * @type number
		 */
		@Prop()
		public mapLatitude!: number;

		/**
		 * @type number
		 */
		@Prop()
		public mapLongitude!: number;

		/**
		 * @type number
		 */
		@Prop()
		public mapZoom!: number;

		/**
		 * @type ChalkySticks/Collection/Venue
		 */
		@Prop({
			default: () =>
				ChalkySticks.Factory.Venue.collection({
					limit: 64,
				}),
		})
		public venueCollection!: ChalkySticks.Collection.Venue;
	}
</script>

<style lang="scss">
	.view-ui-media-map {
		height: 100%;
		position: relative;
		width: 100%;

		.chalky.venue-map {
			height: 100%;
			position: absolute;
			width: 100%;
		}
	}
</style>
